<template>
    <v-card class="mb-4">
      <v-card-title class="d-flex">
        <h3>Metas</h3>
        <v-btn class="ml-4" color="success" data-testid="game-metas-create-btn" @click="$router.push(`/games/${game.id}/metas/new#`)">Create</v-btn>
      </v-card-title>

      <v-card-text>
        <v-text-field label="Search" v-model="search" />
        <v-data-table sort-by="locale" :loading="items?.length === 0" :headers="headers" :items="items" :search="search">
          <template v-slot:item.actions="{ item }">
            <v-icon class="mr-2" @click="editItem(item)" color="primary" :data-testid="`game-metas-edit-${item.id}`">mdi-pencil</v-icon>
            <v-icon @click="deleteItem(item)" color="warning" :data-testid="`game-metas-delete-${item.id}`">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
</template>

<script>
export default {
  name: 'MetasList',
  components: { },
  props: {
    game: {},
    items: []
  },
  data() {
    return {
      search: '',
      headers: [
        { value: 'id', text: 'Id' },
        { value: 'locale', text: 'Locale' },
        { value: 'actions', text: 'Actions', align: 'center' },
      ],
    };
  },
  async created() {

  },
  methods: {
    async editItem(item) {
      this.$router.push(`/games/${this.game.id}/metas/${item.id}#`);
    },
    async deleteItem(item) {
      const { isConfirmed } = await this.$swal.fire({ icon: 'warning', title: 'This will delete all feed infromation. Are you sure to proceed?', showCancelButton: true });
      if (isConfirmed) {
        await this.$gameApi.delete(`/games/${this.game.id}/metas/${item.id}`);
        this.$emit('update');
      }
    },
  }
};
</script>

